import { EmptyObject } from 'libs/end-to-end/src/generic';
import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { NlpGraphResult } from 'libs/end-to-end/src/custom-viz/NlpGraphTypes';

export const NlpGraphCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'nlpGraph',
  outputFileName: 'nlp_graph_results.json',
  isDataQueuingAllowed: false,
  outputSchema: NlpGraphResult,
  extrasSchema: EmptyObject,
  resolveFocusArea: () => null,
  resolveFilters: () => null,
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  eventProperties: (request) => ({
    'Custom Viz Type': request.customVizId,
    'Selected Dimensions': [],
    'Selected Metrics': [],
    'Selected Focus Areas': [],
    Filters: [],
  }),
  getUrlPath: () => 'nlp-graph',
};
